import timeout from '../service/inactivity-timeout-service';
import $ from 'jquery';
import { gsap } from "gsap";


class NewsletterSignupItem {
    constructor(el, i) {
        this.render(el, i)
    }

 
 
 

    signUp(e) {
        e.preventDefault();
        this.status.hide();
        this.statusError.hide()
        if (this.validate()) {
            var data = {

                email: this.emailField.val(),
                '__requestVerificationToken': this.form.find('input[name="__RequestVerificationToken"]').val(),

            };
            $.ajax('/umbraco/surface/newsletter/signup',

                {
                    method: "POST",
                    data: data,
                    success: this.form_SUCCESS.bind(this),
                    error: this.form_ERROR.bind(this)
                }
            )
        }
    }


    form_SUCCESS(data) {
        if (data && data.success) {
            this.hideErrors();
            this.hideForm();
            this.showSuccess();
        }
        else {
            this.handleError.call(this, data.errors);
        }

    }

    hideErrors() {
        this.status.css('display', 'none');
    }
    hideForm() {
        this.form.css('display', 'none');
    }
    showSuccess() {
        this.success.css('display', 'block');
    }

    form_ERROR() {
        this.handleError.call(this, ["Something went wrong while we were signing you up. Please try again later."]);
    }

    handleError(errors) {
        this.status.css('display', 'block');
        this.statusError.css('display', 'block');

        var html = errors.map(function (message) {
            return $("<p/>", { text: message });
        });
        this.statusError.html(html);
    }
    validate() {
        return this.emailField.val().length > 1 && /^.+@.+\..+$/.test(this.emailField.val());
    }

    render(el, i) {

 
        this.el = $(el);

 
 

        this.form = this.el.find('[data-ref="form"]');
        this.emailField = this.form.find('[data-ref="email"]');

        this.status = this.el.find('[data-ref="status"]');
        this.success = this.el.find('[data-ref="status-success"]')
        this.statusError = this.el.find('[data-ref="status-error"]')


       
         



         

        this.form.on('submit', this.signUp.bind(this)); 

    }
}



class NewsletterSignup {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {

        new NewsletterSignupItem(el, index);

    }
}


export default NewsletterSignup;